// The Access Requests guide (43_AccessRequests.jsx · ModuleHelp, Max 01/11).
const en = {
  noteT: 'What this list is',
  noteB: 'People outside Helinox who asked for a portal account. A request is not an account yet: Create account opens Register with their details filled in.',
  toolsT: 'Reload and back to Users',
  toolsB: 'Refresh fetches new requests; Users takes you back to the account list.',
  waitingT: 'Waiting for a decision',
  waitingB: 'Requests nobody has answered yet, with the company, contact and the reason they gave. Click a column title to sort or filter.',
  actionT: 'Create the account or reject',
  actionB: 'Create account opens Register to pick the roles and marks the request once the account exists. Reject asks for a reason first, and the reason is kept.',
  decidedT: 'Already decided',
  decidedB: 'Approved and rejected requests stay here with who decided, when, the note and the username, so a second request from the same person has its answer.',
};
const ko = {
  noteT: '이 목록은',
  noteB: 'Helinox 외부에서 포털 계정을 요청한 사람들입니다. 요청은 아직 계정이 아니며, 계정 만들기를 누르면 입력된 정보가 채워진 Register 화면이 열립니다.',
  toolsT: '새로고침과 사용자 목록',
  toolsB: '새로고침은 새 요청을 가져오고, 사용자 버튼은 계정 목록으로 돌아갑니다.',
  waitingT: '결정 대기',
  waitingB: '아직 답하지 않은 요청과 회사, 연락처, 요청 사유가 나옵니다. 열 제목을 클릭해 정렬하거나 필터하세요.',
  actionT: '계정 만들기 또는 반려',
  actionB: '계정 만들기는 Register를 열어 역할을 고르게 하고, 계정이 만들어지면 요청에 표시합니다. 반려는 사유를 먼저 입력해야 하며 사유가 남습니다.',
  decidedT: '처리 완료',
  decidedB: '승인·반려된 요청이 처리자, 일시, 메모, 사용자명과 함께 남아 있어, 같은 사람이 다시 요청해도 이전 답변을 확인할 수 있습니다.',
};
const vi = {
  noteT: 'Danh sách này là gì',
  noteB: 'Những người ngoài Helinox xin tài khoản portal. Yêu cầu chưa phải là tài khoản: Tạo tài khoản mở trang Register với thông tin đã điền sẵn.',
  toolsT: 'Tải lại và quay về Users',
  toolsB: 'Làm mới lấy các yêu cầu mới; Users đưa bạn về danh sách tài khoản.',
  waitingT: 'Đang chờ quyết định',
  waitingB: 'Các yêu cầu chưa ai trả lời, kèm công ty, liên hệ và lý do người đó nêu. Bấm tiêu đề cột để sắp xếp hoặc lọc.',
  actionT: 'Tạo tài khoản hoặc từ chối',
  actionB: 'Tạo tài khoản mở Register để chọn role và đánh dấu yêu cầu khi tài khoản đã có. Từ chối yêu cầu nhập lý do trước, và lý do được lưu lại.',
  decidedT: 'Đã xử lý',
  decidedB: 'Yêu cầu đã duyệt hoặc từ chối được giữ lại cùng người quyết định, thời điểm, ghi chú và username, để lần xin tiếp theo của cùng một người đã có sẵn câu trả lời.',
};
const zh = {
  noteT: '这个列表是什么',
  noteB: '这是 Helinox 以外的人提出的门户账号申请。申请还不是账号：点击创建账号会打开已填好信息的 Register 页面。',
  toolsT: '刷新与返回用户列表',
  toolsB: '刷新会获取新的申请；Users 带你回到账号列表。',
  waitingT: '等待决定',
  waitingB: '还没有人答复的申请，附有公司、联系方式和申请理由。点击列标题可排序或筛选。',
  actionT: '创建账号或驳回',
  actionB: '创建账号会打开 Register 让你选择角色，账号建好后会标记该申请。驳回需要先填写理由，理由会被保留。',
  decidedT: '已处理',
  decidedB: '已批准和已驳回的申请会连同处理人、时间、备注和用户名一起保留，同一个人再次申请时可以直接查到之前的答复。',
};
const dictionary = { ns: 'tourAccess', en, ko, vi, zh };
export default dictionary;
